import React from "react";

export const CanvasContext = React.createContext<ICanvasContext>({});

export interface ICanvasData {
  component?: string;
  id?: string;
  position?: { top: number; left: number };
  dimension?: { width: string; height: string };
  content?: string;
  type: string;
  /** Saved zoom level for SLIDE (Leaflet map). */
  slideZoom?: number;
  /** Saved camera orbit for 3D model (model-viewer), e.g. "0deg 75deg 2.5m". */
  cameraOrbit?: string;
}

export interface ICanvasComponent {
  position?: { top: number; left: number };
  dimension?: { width: string; height: string };
  content?: string;
  id?: string;
  type: string;
  isReadOnly?: boolean;
  slideZoom?: number;
  cameraOrbit?: string;
}

export interface UploadEntity {
  entity_type: string;
  entity_id: string;
}

export interface ICanvasContext {
  state?: {
    canvasData: ICanvasData[];
    activeSelection: Set<string>;
    enableQuillToolbar: boolean;
  };
  actions?: {
    setCanvasData: React.Dispatch<React.SetStateAction<ICanvasData[]>>;
    setActiveSelection: React.Dispatch<React.SetStateAction<Set<string>>>;
    updateCanvasData: (data: Partial<ICanvasComponent>) => void;
    addElement: (type: string) => void;
    deleteElementById: (elementId: string) => void;
    setEnableQuillToolbar: (state: boolean) => void;
    /** Call after an action completes to persist current canvas (once per action, not on every tick). */
    saveNow: () => void;
    /** Move element one step up (forward) or down (backward) in layer order. */
    moveElementLayer: (elementId: string, direction: "up" | "down") => void;
  };
  uploadEntity?: UploadEntity;
}
